import React from "react"
import { BannerLayout, BannerLink } from "@modules/ui/components/Banner"
import { useFlags } from "@modules/featureFlags"
import { useBanner } from "./hooks/useBanner"

export function MarketingBanner({ name }) {
  const { isVisible, hideBanner } = useBanner(name)

  return isVisible ? (
    <BannerLayout data-testid="marketing-banner" onClose={hideBanner}>
      Take a deep dive into our latest launch, the{" "}
      <BannerLink href="https://www.gatsbyjs.com/products/valhalla-content-hub?utm_source=gc&utm_medium=banner&utm_campaign=valhalla-content-hub">
        Valhalla Content Hub.
      </BannerLink>
    </BannerLayout>
  ) : null
}

export function FlaggedBanner({ name }) {
  const { flags } = useFlags()

  // TODO: rename LD flag
  return flags.showBannerSurvey ? <MarketingBanner name={name} /> : null
}

export default FlaggedBanner
